import { Box, Grid } from '@mui/material'
import { backgroundColors } from '../../Components/Common/Color/Color'
import TaskTargetCompletionChart from '../../Components/Report/TaskReport/Chart/TaskTargetCompletionChart'
import TaskTable from '../../Components/Report/TaskReport/TaskTable'
import TaskParticipantChart from '../../Components/Report/TaskReport/Chart/TaskParticipantChart'
import TaskAssigneesChart from '../../Components/Report/TaskReport/Chart/TaskAssigneesChart'
import { useEffect } from 'react'
import { useAppDispatch } from '../../redux/store'
import { fetchTasksByFilters } from '../../redux/task/actions'

const TaskReportPage = () => {
  const dispatch = useAppDispatch()

  const fetchData = async () => {
    await dispatch(fetchTasksByFilters({})).unwrap()
  }

  useEffect(() => {
    fetchData()
  }, [dispatch])

  return (
    <Box
      component='div'
      sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
      borderRadius={2}
      boxShadow={1}
    >
      <Grid container sx={{ p: 2 }} direction={'column'}>
        <Grid
          container
          sx={{ px: 10 }}
          flexDirection='row'
          alignItems={'center'}
          justifyContent='space-between'
        >
          <Grid>
            <TaskAssigneesChart />
          </Grid>
          <Grid>
            <TaskTargetCompletionChart />
          </Grid>
          <Grid>
            <TaskParticipantChart />
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <TaskTable />
      </Box>
    </Box>
  )
}

export default TaskReportPage
